<!-- HEADER -->
<section
  class="d-flex align-items-center justify-content-between px-4 position-relative"
>
  <!-- LEFT -->
  <div class="d-flex align-items-center">
    <button class="back_icon" (click)="navigateToBackPage()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
    <h2 class="m-0" translate>Subjects</h2>
  </div>

  <!-- RIGHT -->
  <div>
    <button mat-raised-button color="primary" (click)="addEcontent()">
      <i class="fa-solid fa-plus"></i>
      <span translate>Add E-Content</span>
    </button>
  </div>
</section>

<!-- MAIN CONTENT -->
<section class="container section">
  <div class="app-container">
    <main class="content-container">
      <!-- LEFT SIDE (SEMESTERS) -->
      <nav class="semester-nav">
        <ul class="semester-list">
          <li
            *ngFor="let semester of semesters"
            (click)="selectSemester(semester.semister_id)"
            [class.selected]="semester.semister_id === selectedSemester"
            class="semester-item"
          >
            <span class="semester-number">
              <span translate>Semester</span>
              {{ semester.Semester_Number }}
            </span>
            <mat-icon class="chevron-icon">chevron_right</mat-icon>
          </li>
        </ul>
      </nav>

      <!-- RIGHT SIDE (SUBJECTS) -->
      <section class="subject-content">
        <div
          *ngIf="selectedSemester; else noSelection"
          class="subject-container"
        >
          <ul class="subject-list">
            <li
              *ngFor="let subject of subjectsList; let i = index"
              class="subject-item"
              (click)="viewESubjectData(subjectsId[i], subject)"
            >
              <mat-icon class="subject-icon">menu_book</mat-icon>

              <div>
                <div class="subject-name">{{ subject }}</div>
                <div class="subject-code">{{ subjectsCode[i] }}</div>
              </div>
            </li>
          </ul>
        </div>

        <!-- EMPTY STATE -->
        <ng-template #noSelection>
          <div class="empty-state">
            <mat-icon class="empty-icon">select_all</mat-icon>
            <h3 translate>No Semester Selected</h3>
            <p translate>
              Please select a semester from the list to view its subjects
            </p>
          </div>
        </ng-template>
      </section>
    </main>
  </div>
</section>
